import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Form } from "formik";
import * as Yup from "yup";
import FormikActions from "../../commons/formik/formikActions";
import FormikTextField from "../../commons/formik/formikTextField";
import FormikForm from "../formik/formikForm";
import CustomDialog from "./customDialog";

const validation = Yup.object({
  nombre: Yup.string().required("Campo obligatorio"),
});

const EditProviderDialog = ({
  provider,
  open,
  handleClose,
  addingNewProvider,
  handleSubmit,
}) => {
  return (
    <CustomDialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        {addingNewProvider ? "Agregar Prestador" : "Editar Prestador"}
      </DialogTitle>
      <FormikForm
        initialValues={provider}
        validationSchema={validation}
        onSubmit={(values) => {
          handleSubmit(values, addingNewProvider);
        }}>
        <Form>

          <DialogContent>
            <FormikTextField
              margin="dense"
              id="nombre"
              name="nombre"
              label="Razón social"
              type="text"
              fullWidth
            />
            <FormikTextField
              margin="dense"
              id="apiKeyValidadorSiniestros"
              name="apiKeyValidadorSiniestros"
              label="Api Key Validador Siniestros"
              type="text"
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <FormikActions handleCancel={handleClose} />
          </DialogActions>
        </Form>
      </FormikForm>
    </CustomDialog>
  );
};

export default EditProviderDialog;
